import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8v6a2 2 0 1 0 4 0v-6","key":"svg-0"}]]

const IconLetterUSmall = createReactComponent('outline', 'letter-u-small', 'LetterUSmall', __iconNode);

export default IconLetterUSmall;